import React from "react";

import MoreIcon from "material-ui/svg-icons/navigation/more-horiz";
import IconButton from "material-ui/IconButton";
import AddIcon from "material-ui/svg-icons/content/add";
import EditIcon from "material-ui/svg-icons/image/edit";
import CopyIcon from "material-ui/svg-icons/content/content-copy";
import DeleteIcon from "material-ui/svg-icons/action/delete";
import DownloadIcon from "material-ui/svg-icons/content/save";
import Menu from "material-ui/Menu";
import MenuItem from "material-ui/MenuItem";

const backDropStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 10000
};

const menuStyle = {
  height: "215px",
  background: "#f3f3f3",
  position: "absolute",
  zIndex: 100001,
  overflow: "hidden",
  left: "-50px"
};

class TemplateList extends React.Component {
  state = {
    openId: null
  };

  componentDidMount() {
    const { templates, onActive } = this.props;
    const firstInList = Object.values(templates.list)[0];
    onActive(firstInList);
  }

  componentWillReceiveProps(nextProps) {
    const { templates } = nextProps;
    if (
      Object.keys(templates.list).length !==
      Object.keys(this.props.templates.list).length
    ) {
      const list = Object.values(templates.list);
      const lastInList = list[list.length - 1];
      this.props.onActive(lastInList);
    }
  }

  onOpen = id => {
    this.setState({ openId: id });
  };
  onClose = () => {
    this.setState({ openId: null });
  };

  onEdit = template => {
    this.props.onActiveEdit(template);
    this.onClose();
  };

  onDelete = id => {
    this.props.onDelete(id);
    this.onClose();
  };

  onDownload = template => {
    const { onDownloadTemplate } = this.props;

    onDownloadTemplate(template);
    this.onClose();
  };

  onCopy = template => {
    this.props.onCopy(template);
    this.onClose();
  };

  render() {
    const { onActive, activeId, templates } = this.props;
    const { openId } = this.state;
    const list =
      Object.keys((templates && templates.list) || {}).length > 0
        ? Object.values(templates.list)
        : [];

    return (
      <div className="wrap-navigation-templates">
        <div style={{ width: "250px !important" }}>
          {list.map(template => (
            <div key={template.id}>
              <div
                className={`card-templates ${
                  activeId === template.id ? "card-templates_active" : ""
                }`}
              >
                <div
                  className="card-templates-text"
                  onClick={() => onActive(template)}
                >
                  {template.title}
                </div>
                <div className="card-templates-action">
                  <IconButton
                    onClick={() => this.onOpen(template.id)}
                    style={{ zIndex: 100000 }}
                  >
                    <MoreIcon />
                  </IconButton>
                  <Menu
                    id="long-menu"
                    style={{ zIndex: 100001 }}
                    onClose={this.onClose}
                  >
                    <div
                      style={{
                        display: openId === template.id ? "block" : "none",
                        ...menuStyle
                      }}
                    >
                      <MenuItem>
                        <IconButton
                          onClick={() => this.onEdit(template)}
                          tooltipPosition="bottom-center"
                          tooltip="edit"
                        >
                          <EditIcon />
                        </IconButton>
                      </MenuItem>
                      <MenuItem>
                        <IconButton
                          onClick={() => this.onCopy(template)}
                          tooltipPosition="top-center"
                          tooltip="copy"
                        >
                          <CopyIcon />
                        </IconButton>
                      </MenuItem>
                      <MenuItem>
                        <IconButton
                          onClick={() => this.onDownload(template)}
                          tooltipPosition="top-center"
                          tooltip="download"
                        >
                          <DownloadIcon />
                        </IconButton>
                      </MenuItem>
                      <MenuItem>
                        <IconButton
                          onClick={() => this.onDelete(template.id)}
                          tooltipPosition="top-center"
                          tooltip="delete"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </MenuItem>
                    </div>
                  </Menu>
                  {openId === template.id && (
                    <div style={backDropStyle} onClick={this.onClose} />
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default TemplateList;
